import axios, { AxiosError } from 'axios';
import { XhrDefaultTimeout } from './constants';
import PathManagement, { XhrQueryParam } from './path-management';

export interface XhrStatusResponse<T = null> {
  statusCode: number;
  statusMsg: string;
  statusDetail: string;
  data: T;
}

export const operationSuccess = (s?: XhrStatusResponse<any>): boolean => {
  return s!! && s.statusCode === 200;
};

export const getAction = async <T = XhrStatusResponse>(
  action: string,
  params?: XhrQueryParam[]
): Promise<T | undefined> => {
  try {
    const pathManager = new PathManagement();
    const url = pathManager.getUrlForAction(action, params);
    const res = await axios.get<T>(url, { withCredentials: true, timeout: XhrDefaultTimeout });
    let _res = res.data;
    // _res = decryptResponse(res.data);
    return _res;
  } catch (e) {
    if (typeof e == 'object' && e && 'isAxiosError' in e) {
      const axiosError = e as AxiosError;
      console.error(axiosError);
    }
  }

  return undefined;
};

export const postAction = async <T = unknown, S = XhrStatusResponse>(
  action: string,
  data: T,
  params?: XhrQueryParam[]
): Promise<S | undefined> => {
  const url = new PathManagement().getUrlForAction(action, params);
  return postResponseByUrl<S, T>(url, data);
};

export const postEntityAction = async <T = unknown, S = XhrStatusResponse>(
  entity: string,
  action: string,
  data: T,
  params?: XhrQueryParam[]
): Promise<S | undefined> => {
  const url = new PathManagement().getUrlForEntityAction(entity, action, params);
  return postResponseByUrl<S, T>(url, data);
};

export const getResponseByUrl = async <T = XhrStatusResponse>(url: string): Promise<T | undefined> => {
  try {
    const res = await axios.get<T>(url, { withCredentials: true, timeout: XhrDefaultTimeout });
    let _res = res.data;
    // _res = decryptResponse(res.data);
    return _res;
  } catch (e) {
    if (typeof e == 'object' && e && 'isAxiosError' in e) {
      const axiosError = e as AxiosError;
      console.error(axiosError);
    }
  }

  return undefined;
};

export const patchResponseByUrl = async <T = XhrStatusResponse>(
  url: string,
  dataToPost: any
): Promise<T | undefined> => {
  try {
    
    let response = await axios.patch(url, dataToPost, { withCredentials: true, timeout: XhrDefaultTimeout });
    return response.data;

  } catch (e) {
    if (typeof e == 'object' && e && 'isAxiosError' in e) {
      const axiosError = e as AxiosError;      
    }
  }

  return undefined;
};

export const putResponseByUrl = async <T = XhrStatusResponse>(
  url: string,
  dataToPost: any
): Promise<T | undefined> => {
  try {
    let response = await axios.put(url, dataToPost, { withCredentials: true, timeout: XhrDefaultTimeout });
    return response.data;
  } catch (e) {
    if (typeof e == 'object' && e && 'isAxiosError' in e) {
      const axiosError = e as AxiosError;
      console.error(axiosError);
    }
  }

  return undefined;
};

export const postResponseByUrl = async <T = XhrStatusResponse, S = unknown>(
  url: string,
  dataToPost: S
): Promise<T | undefined> => {
  try {
    let response = await axios.post<T>(url, dataToPost, {
      withCredentials: true,
      timeout: XhrDefaultTimeout,
    });
    return response.data;
  } catch (e) {
    if (typeof e == 'object' && e && 'isAxiosError' in e) {
      const axiosError = e as AxiosError;
      console.error(axiosError);
    }
  }

  return undefined;
};

export const deleteResponseByUrl = async <T = XhrStatusResponse, S = unknown>(
  url: string
): Promise<T | undefined> => {
  try {
    let response = await axios.delete<T>(url, {
      withCredentials: true,
      timeout: XhrDefaultTimeout,
    });
    return response.data;
  } catch (e) {
    if (typeof e == 'object' && e && 'isAxiosError' in e) {
      const axiosError = e as AxiosError;
      console.error(axiosError);
    }
  }
  return undefined;
};
